// Sdílené konstanty/helpery pro produkty s jevy (DlyJevyView, StationGroupJevyView).

export const PHENO_LEGEND_LABELS = [
  { code: 'DE', label: 'Den s deštěm' },
  { code: 'JI', label: 'Den s jíním, jinovatkou' },
  { code: 'KR', label: 'Den s kroupama' },
  { code: 'LE', label: 'Den s ledovkou' },
  { code: 'ML', label: 'Den s mlhou' },
  { code: 'NA', label: 'Den s námrazou' },
  { code: 'RO', label: 'Den s rosou' },
  { code: 'SN', label: 'Den se sněžením' },
  { code: 'SV', label: 'Den se silným větrem' },
]

export const PHENO_LEGEND_MAP = new Map(PHENO_LEGEND_LABELS.map(({ code, label }) => [code, label]))

function daysInMonth(year, month) {
  return new Date(year, month, 0).getDate()
}

// Pole klíčů "YYYY-MM-DD" pro všechny dny daného měsíce.
export function buildDayKeys(year, month) {
  const count = daysInMonth(year, month)
  const mm = String(month).padStart(2, '0')
  return Array.from({ length: count }, (_, i) => {
    const dd = String(i + 1).padStart(2, '0')
    return `${year}-${mm}-${dd}`
  })
}
